const iconColor = '#4527a4';
const icons = {
	sticky: <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 388.266 388.266'>
		<path fill={iconColor} d='M388.172,55.218L116.189,1.089l-0.654-0.128L26.397,1.125L0,1.089v386.216h388.266V64.598L388.172,55.218z M319.291,144.434C293.78,121.517,213.527,66.745,159.834,30.772l206.154,42.069C361.865,90.479,350.016,126.11,319.291,144.434z M321.917,166.114c21.45-10.299,36.072-26.548,45.986-43.079v243.904H20.362V21.497l4.5-0.011l84.381,0.112 c67.822,44.747,184.602,123.856,200.608,142.056l5.089,5.787L321.917,166.114z' />
	</svg>
}
export default icons;